import React from "react";
//<style>.cls-1{fill:#fff200;}</style>
export const Level1 = (props) => {
  const { callback } = props;
  const onClick = (e) => {
    e.preventDefault();
    const num = e.currentTarget.attributes.name.nodeValue;
    callback(num);
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1927.56 1077.17">
      <g id="Capa_15">
        <path
          style={{ fill: "transparent" }}
          className="st0"
          d="M272.4,242.2L272.4,242.2c1.5,26.6,2.6,53.2,3.5,79.8c0.9,26.6,1.5,53.2,1.9,79.8c0.2,15,0.3,29.9,0.3,44.9
		c0,1.4,1.1,2.5,2.5,2.5c25.3,0.7,50.6,0.9,75.9,0.6c25.3-0.3,50.7-1.1,76.1-2.4c12.6-0.7,25.3-1.4,37.9-2.3
		c12.3-0.9,24.7-2.5,37-1.9c5.3,0.4,10.6,1.2,15.8,2.4c4.2,0.9,8.7,1.7,13,1.3s8.1-2.1,10.4-5.9c1.3-2.4,2-5,2.1-7.7
		c0.2-3.1,0.1-6.2,0.2-9.2l1.4-76.6l1.3-76.3c0.1-6.2,0.2-12.5,0.3-18.7c0.1-4.9-0.1-9.9-2.1-14.4c-4.7-10.7-17.8-9.9-27.6-10.2
		c-25.3-0.7-50.5-0.8-75.8-0.6s-50.5,1.1-75.8,2.3c-25.2,1.2-50.5,3-75.6,5.1c-6.2,0.5-12.3,1.1-18.5,1.7c-1.4,0-2.5,1.1-2.5,2.5
        c0,1.4,1.1,2.5,2.5,2.5"
          onClick={onClick}
          name="1"
        />

        <path
          style={{ fill: "transparent" }}
          className="st0"
          onClick={onClick}
          name="2"
          d="M663.2,443.1c-3.1-0.7-4.5,4.1-1.3,4.8c5.1,1.1,10.4,1.2,15.5,0.3c5-1,9.9-2.9,14.2-5.7
		c2.1-1.4,4.4-2.5,6.8-3.1c2.6-0.4,5.3-0.5,8-0.1l17.5,1.5l19.7,1.7l-2.5-2.5c0.5,8.4,4.7,16.1,11.5,21c6.6,4.9,15.1,6.4,23,4
		c7.9-2.5,14.4-8.3,17.7-15.9c1.9-4.7,2.2-9.9,2.1-14.9c0-4.5-0.3-9.2,0.8-13.7c0.8-3.4,2.4-6.9,5.2-9.1s6.1-2.3,9.2-1.5
		c7.5,1.9,14.1,7.5,22.2,6.6c7.9-0.9,12.8-7.2,15.6-14.1c1.4-3.5,2.4-7.1,3-10.8c1-5,1.7-10.1,2.4-15.2c1.4-10.7,2.1-21.6,0-32.3
		c-1.6-8.2-5.2-15.9-10.4-22.5c-5.1-6.5-12.2-11.1-20.2-13.1c-2.9-0.9-7-1.8-8.3-4.8c-0.3-0.9-0.5-1.7-0.7-2.6
		c-0.3-1.2-0.8-2.4-1.6-3.4c-1.5-1.7-3.8-2.3-6-2.5c-2.4-0.2-4.9,0-7.3,0l-8.2,0.1l-16.7,0.1l-33.1,0.3c-9.3,0.1-19.9-0.6-28,4.9
		c-6.5,4.4-9.8,11.6-12.5,18.7s-4.8,14.6-9.8,20.4c-5.7,6.6-13.6,10.6-21.1,14.6s-15.2,8.3-21.1,14.7c-2.9,3.1-5.1,6.7-6.6,10.6
		c-1.6,4.7-2,9.7-1.1,14.6c1,5,2.5,9.8,4.5,14.5l3.1-3.1c-5.8-1.6-13.5-2.3-18.6,1.6c-2.7,2.1-3.9,5.5-3.3,8.8c0.8,4,4.3,6.9,8,8.1
		c5.3,1.7,10.9-0.4,15.7-2.3l-3.1-1.8c3.2,9.3,8.5,17.8,15.5,24.7c2.3,2.2,5.8-1.3,3.5-3.5l0,0"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="3"
          className="st0"
          d="M1036.6,417.6c-4.1-1.6-9.4-0.9-11.8,3.2c-1.6,2.8,2.7,5.3,4.3,2.5c0.8-1.4,2.3-1.7,4-1.5
		c2.1,0.4,4,1.4,5.4,2.9c2.1,1.9,4,4,6.2,5.8c2,1.5,4.3,2.6,6.8,3.2c4.9,1.3,10,1.1,15.1,1.1c4.6,0,9.7,0,13.9,2.1s7.1,6.4,9.8,10.2
		c3,4.3,6.2,8.3,10.8,11c8.8,5.2,20.5,5.4,29.1-0.2c4.3-2.8,7.7-6.7,10-11.3c2.2-4.8,3.2-10,2.8-15.3c-0.2-2.6-0.4-5.2,0.3-7.8
		c0.5-1.6,1.5-2.9,2.9-3.6c0.5-0.3,1.1-0.5,1.7-0.6l0.6-0.1c-0.5,0.1,0.1,0,0.2,0c0.5,0,0.9,0,1.4,0c1.7,0,3.4,0.2,5,0.6
		c7.6,1.6,16.9,5.2,24.1,0.5c4.2-2.8,6.3-7.5,7.4-12.2c1.1-5.6,1.8-11.2,2-16.9c1.5-24.4-2.1-48.9-10.4-71.9
		c-2-5.5-4.1-11.3-7.1-16.3c-3-4.9-7.7-8.4-13.2-9.9c-5.7-1.7-11.8-2.1-17.6-2.8c-6.6-0.7-13.1-1.4-19.7-1.9
		c-13-1-26.1-1.7-39.2-1.6c-12.1,0-24.5,1.1-35.7,6.1c-9,4-17.3,11.1-21.6,20.1c-1.1,2.3-2,4.7-2.5,7.2c-0.5,2.5-0.7,5.1-0.8,7.7
		c-0.1,2.1-0.3,4.5-1.9,6.1c-1.4,1.2-3.2,1.8-5,1.7c-4.8,0.2-9.7-0.7-14.3,1.5s-6.8,6.8-10.4,10c-6.1,5.5-16.3,3.6-22,10.1
		c-1.7,2-2.7,4.5-2.9,7.1c-0.3,2.9,0.3,5.8,0.1,8.7c-0.3,4.5-3.6,8.4-6.3,11.8c-3,4-5.8,8.1-6.2,13.2c-0.3,4.6,1.1,9.1,3.9,12.8
		c2.7,3.7,6.8,6.3,11.3,7.2l-1.7-3.1c-3.5,10.5,3.2,21.3,12.2,26.6c10.3,6,22.7,3.8,32.6-2c5.8-3.5,11-8,15.4-13.2
		c0.9-1,0.9-2.5,0-3.5c-1-1-2.6-1-3.5,0l0,0"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="4"
          className="st0"
          d="M1271.4,364c-1.7,2.8,2.7,5.3,4.3,2.5l-0.1-0.1c0.3-0.5,0.1,0-0.1,0s-0.6,0.3-0.4,0.1c0.1,0-0.3-0.2,0.1,0
		c-0.4-0.3,0.2,0.2,0.3,0.2c-0.3-0.2,0.6,0.6,0.4,0.4c0.3,0.3,0.5,0.7,0.6,1.1c0.2,0.8,0-0.2,0,0.3c0,0.1-0.1,0.6,0,0.3
		c-0.2,0.4-0.4,0.8-0.7,1.2c-0.8,0.9-1.8,1.8-2.8,2.5c-2.4,1.7-4.7,3.5-6.1,6.1c-1.4,2.7-2,5.7-1.9,8.8c0.1,6.6,2.4,13.2,4,19.6
		s3,13,5,19.3c3.1,10,8.9,21.1,20.3,23c13.9,2.2,24.5-8.8,34-17c5.4-4.7,11.2-8.4,18.4-9.6c7.5-1.3,15.4-0.2,22.9,0.9l-1.8-2.4
		c-1.4,10.6,3.2,21.3,10.5,28.9c7.8,8.1,18.6,12.7,29.9,12.7c11.9,0.2,23.2-5.1,30.6-14.5c3.4-4.3,5.7-9.4,6.7-14.8
		c0.5-2.9,0.7-5.8,0.5-8.7c-0.2-2.9-0.6-6,0.7-8.7c1.1-2.1,2.8-3.8,4.9-5c2.5-1.6,5.3-2.9,8-4.2l18.8-9.6c1.3-0.8,2.7-1.5,4.2-2.1
		c1.1-0.4,1.2-0.1,1.6,0.8c0.9,2.3,1.4,4.6,2.8,6.6c2.9,4,7.2,6.7,12,7.8c10.9,2.4,20.9-4.1,26.4-13.2c1.4-2.4,2.6-5,3.4-7.7
		c1-3,1.6-6.1,3-8.9s3.3-5.1,5-7.7c1.6-2.4,2.6-5.2,3.2-8c2-11.6-4.2-22.5-7.2-33.3c-0.7-2.8-1.3-5.7-1.7-8.5
		c-0.3-2.9-1.3-5.7-2.9-8.1c-2.8-3.8-6.9-5.4-11.5-5.8s-8.9,0.2-13.3,0.3c-4,0.1-8.4-0.1-11.7-2.5c-3.5-2.6-4.7-7.1-5.8-11.1
		c-1.2-4.7-2.1-9.6-4.6-13.8c-6-10-18.9-12.3-29.3-15.1c-13.2-3.5-26.7-6.7-40.4-7.6c-21.8-1.3-46.3,4.6-60.5,22.5
		c-7,8.8-10,20.2-18.5,27.9c-6.2,5.7-14,9.3-21.8,12.4c-15.7,6.3-34.4,11.4-43.9,26.7c-2.6,4.2-4.6,10,0.1,13.6
		c1.2,0.7,2.7,0.3,3.4-0.9c0.7-1.2,0.3-2.7-0.9-3.4c-1.1-0.8,0-3.6,0.5-4.6c0.9-1.7,1.9-3.4,3.2-4.9"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="5"
          className="st0"
          d="M339.2,635.6c-1.5-2.9-5.8-0.3-4.3,2.5c5.6,11,16.9,18.3,28.9,20.4c6.1,1.1,12.3,0.8,18.2-0.9
		c7-2,12.2-6.5,18-10.7c7-5,14.8-6.3,23.2-7.1c9.4-0.9,18.8-1.7,28.2-2.3c18.7-1.2,37.4-1.6,56.1-1.5c8.9,0.1,17.8,0,26.7,0.9
		c4,0.4,8,1.2,11.8,2.6c3.8,1.5,7.3,3.7,10.3,6.4c5.7,4.8,11.2,9.1,18.4,11.4c6.6,2,13.5,2.6,20.3,1.5c6.7-0.9,13-3.4,18.6-7.2
		c6.2-4.4,10.4-11.5,17.3-14.9s15.2-2.7,22.6-1.8c8.6,1.1,17.7,2.7,26.1-0.1c6.6-2.1,12.6-7.2,14.8-13.8c1.1-3.3,1-6.9-0.2-10.2
		c-1.2-3.4-3.3-6.5-4.3-10c-1-3.7,1.1-6,3.2-8.8c2.4-3.1,3.5-6.7,2.4-10.6c-2-6.9-8.3-11.6-14.7-14.2c-7.4-3-15.5-3.3-23.3-3.6
		c-8.5-0.4-16.6-1.4-24.4-5.2c-14-6.8-25.5-17.7-39.8-24.2c-14.8-6.8-30.8-10-47-11.6c-16.4-1.6-33.1-1.6-49.6-1.3
		c-8.7,0.2-17.5,0.8-26,3c-7.9,2.1-15.1,5.8-21.9,10.1s-13.4,8.8-20.7,12.3c-7.8,3.7-16.4,5.3-24.9,6.1c-8.9,0.8-17.8,1-26.7,1.9
		c-9.1,0.9-18.2,2.1-27.2,3.7c-9,1.6-17.9,3.6-26.7,6c-6.3,1.7-13.1,4.1-17.6,9c-2.4,2.7-4,6-4.7,9.6c-0.3,1.9-0.9,3.7-1.8,5.4
		c-1.2,1.8-2.5,3.5-4,5c-4.1,5-6.1,11.4-5.5,17.8c0.6,6.6,3.4,12.7,7.9,17.5c4.9,5.2,11.9,8.3,18.9,9.3c7.2,1,14.5,0.2,21.3-2.2"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="6"
          className="st0"
          d="M770.1,606.9c-2.7,5.9,1,11.7,6,15c4.7,3.1,11.6,3.7,14.8,8.8c1.7,2.8,2.5,6,4.2,8.8c1.5,2.5,3.5,4.8,5.7,6.7
		c4.9,3.9,10.5,6.8,16.6,8.3c12.3,3.3,25.3,2.8,37.3-1.5c5.9-2.1,11.5-5,16.5-8.8c2.6-2,5-4.3,7.8-5.9c3.3-1.8,7.1-1.8,10.7-2
		l47.2-2.8l24-1.5c7.6-0.5,15.2-1.3,22.8-1.2c3.5,0,7,0.7,10.3,2.1c2.8,1.5,5.4,3.2,7.7,5.3c5,4.2,9.9,8.2,16.3,10
		c6.7,2,13.8,2,20.7,2c6.9,0.1,13.9-0.3,20.8-1.1c6.8-0.8,13.5-2.7,19.7-5.7c5.7-2.9,10.7-6.9,16-10.4s11.1-6.6,17.6-7.1
		c7.2-0.6,14.3,1.3,21,3.8c3.5,1.3,6.9,2.8,10.3,4.3c1.2,0.7,2.8,0.2,3.4-1c0.2-0.4,0.3-0.8,0.3-1.2c0.2-19.7,0.8-39.4,0.7-59.1
		c0-8.4-0.7-17.3-5.1-24.7c-3.6-6-9.1-10.7-15.6-13.4c-15.1-6.6-31.3-4.6-47.2-4.3c-9.3,0.2-18.7-0.5-27.3-4.2
		c-4.3-1.8-8.3-4.1-12.5-6.1c-4-1.9-8.1-3.5-12.2-4.9c-16.8-5.6-34.7-7.4-52.3-7.8c-8.9-0.2-17.9-0.1-26.8,0.1
		c-7.9,0-15.8,0.5-23.7,1.5c-7.6,0.9-15,3-21.9,6.4c-3.4,1.7-6.5,3.9-9.2,6.5c-2.9,2.8-5.5,5.8-8,9c-2.5,3.1-5.2,6.1-8.7,8.2
		c-3.3,1.9-7,3.1-10.8,3.6c-8.1,1.1-16.3-0.2-24.4-0.7c-16.2-1.3-32.4,2.5-46.5,10.7c-6.8,4-13.6,9.2-18.5,15.5
		c-2.9,3.7-3.8,7.7-3.2,12.3c0.5,4.2,0.8,8.1-0.5,12.3c-1.2,3.7-3.3,7.1-6.2,9.7c-2.4,2.2,1.2,5.7,3.5,3.5"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="7"
          className="st0"
          d="M1254,581.9c-2.6,9.5-4.9,22.1,1.4,30.6c3.6,4.9,9,6.8,14.9,7.4c3.2,0.3,6.4,0.3,9.6,0.8
		c3,0.5,5.8,1.6,8.2,3.4c2.6,1.8,4.8,4,7.4,5.9c2.6,1.9,5.4,3.3,8.5,4.3c6.1,1.9,12.6,1.7,18.8,0.8c6.5-1.1,12.9-2.6,19.2-4.5
		c7.1-2,14.3-3.7,21.6-5c14.7-2.6,29.6-3.8,44.5-4.5c7.5-0.4,15.1-0.8,22.6-1s14.9-0.3,22.2,0.9c7,1.2,13.5,3.8,20,6.5
		s13.2,5,20.3,5.9c6.9,0.8,13.9,0.4,20.7-1.2c6.6-1.5,12.6-4.5,18.5-7.6c5.4-2.9,11.2-6.2,17.5-6.5c6.8-0.4,13.2,3,20,1.8
		c2.7-0.4,5.2-1.7,7.2-3.6c2.3-2.4,3-5.5,3.1-8.8c0.3-7.2,0.1-14.4-0.5-21.6c-1.1-13.1-4.8-26.1-13.9-35.9
		c-3.9-4.2-8.7-7.5-14.1-9.4c-6-2.2-12.4-1.9-18.7-2.8c-3.1-0.3-6-1.3-8.7-2.8c-2.5-1.7-4.6-3.8-6.4-6.2c-1.9-2.5-3.6-5-5.7-7.3
		c-2.2-2.5-4.7-4.6-7.4-6.5c-5.4-3.6-11.2-6.5-17.4-8.6c-5.8-2.2-11.7-3.9-17.7-5.2c-24.2-5.2-49.2-4.1-72.8,3.3
		c-11.7,3.6-22.8,8.8-33.1,15.3c-5.4,3.4-10.3,7.4-15.3,11.3c-2.5,2.1-5.3,3.7-8.4,4.9c-3.4,1-6.8,1.5-10.3,1.4
		c-7,0-13.9-0.7-20.9-0.5c-7,0.1-13.9,1.1-20.7,3c-11.8,3.5-22.7,11.2-28,22.5c-2.6,5.2-3.6,11.1-2.9,16.9L1254,581.9z"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="8"
          className="st0"
          d="M381.8,842c2.5,13.9,11.2,26,23.6,32.9c3.6,2,7.4,3.7,10.8,6.1c3,2.3,5.7,4.9,8,7.9c4.9,6.3,9.2,13,12.8,20.2
		c3.5,7.1,6.4,14.5,8.8,22.1c2.4,7,5.4,13.9,11.3,18.6c11.4,9.2,26.9,9.2,40.4,5.7c8.1-2.1,15.8-5.2,23.7-7.9
		c7.9-2.7,15.9-4.9,24-6.5c16.5-3.4,33.2-5,50-5.9c8.5-0.4,17-0.7,25.5-0.9s17.1-0.7,25.6,0c4.3,0.3,8.6,1.1,12.8,2.4
		c3.8,1.3,7.7,2.4,11.6,3.2c6.5,1.1,13.2,0.2,19.2-2.6c11.5-5.4,20.3-17.4,20.1-30.4c-0.1-4.2-1-8.2-1.4-12.3
		c-0.4-3.7-0.2-7.5,0.5-11.2c1.3-7.2,3.8-14,5.3-21.1c1.4-6.7,2-13.8-0.7-20.3c-2.4-5.6-6.6-10.2-11.9-13
		c-11.2-6.2-24.4-6.5-36.6-9.4c-8.2-2-16.3-4.6-24.1-7.8c-7.2-2.8-14.5-5.7-21.5-9c-6.3-3-12.4-6.5-17.3-11.4s-7.7-11.5-10.5-17.8
		s-5.9-12.8-11.3-17.3s-11.9-6.8-18.6-8.2c-7.3-1.4-14.8-1.8-22.2-2.2l-26.9-1.7l-26.9-1.8c-8-0.5-16-1.2-24-1.3
		c-14.4-0.1-28.9,2.3-39.9,12.2c-8.9,8-14.9,19.8-25.9,25.3c-3.1,1.5-6.4,1.8-9.6,3c-3.2,1.1-5.7,3.5-7.1,6.5
		c-1.2,3.2-1.8,6.6-1.8,10c-0.1,4.3-0.1,8.7-0.1,13c0.1,8.8,0.4,17.6,1,26.3L381.8,842z"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="9"
          className="st0"
          d="M843.7,861.1c-1.3,0-2.4,1.1-2.5,2.5c-2,16.2-0.5,32.7,4.6,48.2c2.2,6.6,4.7,14.1,11.8,16.8
		c3.4,1.3,7.2,1.2,10.9,1.2l13.2-0.1l104.6-0.9l105.2-0.9l26.2-0.2c3.8,0,7.8,0.3,11.4-1c3.1-1,5.6-3.2,7.2-6
		c3.2-6,2.5-13.3,2.2-19.8l-1.2-26.1c-1.6-34.9-3.3-69.8-4.9-104.7l-2.4-52.2l-0.6-13.2c-0.2-3.6-0.4-7.4-3.4-9.8
		c-2.5-2.1-5.9-2.4-9.1-2.4c-4.3,0-8.7,0.1-13,0.1l-105,0.9l-105,0.9c-17.2,0.2-34.5-0.2-51.7,1.9c-3.8,0.5-8,0.7-11.5,2.2
		s-4.8,4.8-5.1,8.3c-0.4,4,0,8.2,0.2,12.2c0.1,4.2,0.3,8.4,0.5,12.6c1.7,34.3,5.7,68.4,12,102.2c1.5,8.1,3.1,16.1,4.9,24.2
		c0.7,3.1,5.4,1.8,4.8-1.3"
        />
        <path
          style={{ fill: "transparent" }}
          onClick={onClick}
          name="10"
          className="st0"
          d="M1213.8,868.5c-4.8,4.2-4.4,11.9-0.9,16.8c4.2,5.8,11.3,9.1,17.6,12.3c13.7,6.9,28.2,12,43.2,15.2
		c7.6,1.6,15.3,2.7,23,3.3c7.3,0.6,14.7,0.6,21.8,2.5c3.4,0.9,6.7,2.4,9.6,4.5c3,2.1,5.7,4.6,8.7,6.7c4.5,3.1,9.5,5.3,14.9,6.3
		c11,2.2,22.4,0.5,32.2-4.8c4.8-2.5,9-5.9,12.6-10c1.8-2.1,3.3-4.3,4.7-6.7c1.6-3,2.8-6.3,4.8-9.2s5.1-4.5,8.2-5.8
		c3.7-1.6,7.6-2.9,11.3-4.4l24.1-9.2l12.2-4.7c3.7-1.4,7.4-2.9,11.2-4c3.5-1,7.1-1.4,10.8-1c3.3,0.5,6.6,1.3,9.8,2.3
		c6.2,1.8,12.9,3.7,19.4,2.1s11-6.9,14.4-12.5c1.9-3,3.6-6.1,5.6-9c2.1-3.1,4.4-6.2,6.6-9.2c4.4-6,8.8-12.1,11.8-19
		c2.8-6.4,4.6-13.6,4-20.6c-0.7-7.2-3.9-14-9.1-19c-5.6-5.7-12.2-10.5-18.3-15.6c-6.4-5.3-12.8-10.6-19.2-15.9
		c-11.6-9.6-23.8-18.9-38.6-22.9c-15.2-4.1-31.5-3.5-47.1-3.3c-28.9,0.3-61.5,3.3-82.4,25.8c-4.7,5-7.7,11.1-12.1,16.3
		c-4.8,5.7-11.4,7.9-18.5,9.4c-14.3,3.1-28.9,4.2-43.2,7c-13.6,2.6-27.6,6.8-38.8,15.3c-5.3,4.1-10,9.1-12.7,15.4
		c-3.1,7.3-2.4,15.1-1.7,22.9l2,24.6L1213.8,868.5z"
        />
      </g>
    </svg>
  );
};
